import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Button, Spinner } from 'lp-components'
import * as actions from '../actions'
import * as apiActions from 'api-actions'
import { selectors } from '../reducer'
import { MembershipType } from 'types'
import { parseQuery, withApiAuth } from 'utils'
import MembershipCard from 'member-portal/components/MembershipCard'

const propTypes = {
  clearMembershipAndAor: PropTypes.func.isRequired,
  fetchMembershipAndAor: PropTypes.func.isRequired,
  membershipAndAor: MembershipType,
}

function MembershipCardViewPrint({
  clearMembershipAndAor,
  fetchMembershipAndAor,
  membershipAndAor,
}) {
  const { search } = useLocation()
  const { membershipId } = parseQuery(search)

  useEffect(() => {
    fetchMembershipAndAor(membershipId)

    return () => clearMembershipAndAor()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!membershipAndAor) return <Spinner />

  return (
    <section className="print-and-view">
      <MembershipCard membershipAndAor={membershipAndAor} />
      <Button
        className="B-primary printer-left-button-icon"
        onClick={() => window.print()}
      >
        Print Page
      </Button>
    </section>
  )
}

MembershipCardViewPrint.propTypes = propTypes

function mapStateToProps(state) {
  return {
    membershipAndAor: selectors.membershipAndAor(state),
  }
}

const mapDispatchToProps = {
  clearMembershipAndAor: actions.clearMembershipAndAor,
}

const mapApiAuthToProps = {
  fetchMembershipAndAor: apiActions.fetchMembershipAndAor,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withApiAuth(mapApiAuthToProps),
)(MembershipCardViewPrint)
